import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M23.5 5.962c-.3-.195-.7-.097-1 .098l-5.4 3.715-.1-.098V6.842c0-1.662-1.3-2.932-3-2.932h-3.3c-.6 0-1 .392-1 .978 0 .587.4.978 1 .978H14c.6 0 1 .39 1 .977v3.226c0 .293.1.49.3.685l1 .977c.3.293.9.391 1.3.098L22 8.8v7.82c0 .587.4.978 1 .978s1-.39 1-.978V6.842c0-.39-.2-.684-.5-.88m-6.8 8.994L5.7 4.203l-4-3.91a.98.98 0 0 0-1.4 0 .93.93 0 0 0 0 1.368L2.6 3.91A2.974 2.974 0 0 0 0 6.842v9.776c0 1.662 1.3 2.933 3 2.933h11c1.2 0 2.3-.782 2.8-1.76l5.5 5.377c.2.195.5.293.7.293s.5-.098.7-.293a.93.93 0 0 0 0-1.369zM15 16.618c0 .587-.4.978-1 .978H3c-.6 0-1-.39-1-.978V6.842c0-.586.4-.977 1-.977h1.6L15 16.03z"
    }, null, -1)
  ]))]))
}
export default { render: render }